// @ts-nocheck


import { DownOutlined, UpOutlined } from '@ant-design/icons';
import React, { Component } from 'react';

import AntIcon from '../../../../components/ant/Icon';
import AntTable from 'antd/lib/table';
import styled from 'styled-components';


import { getListInitialState } from '../../../../lib/helpers';



const StyledTable = styled(AntTable).withConfig({ displayName: "Table__StyledTable", componentId: "sc-1ilm4bz-0" })([".ant-table-row-colored{background:#cccccc;}.ant-table-thead > tr > th,.ant-table-tbody > tr > td{text-overflow:initial;white-space:pre-line;}.ant-table-scroll > div.ant-table-header > table,.ant-table-scroll > div.ant-table-body > table{width:100% !important;}"]);




























export default class extends Component {
  state = {
    ...getListInitialState()
  };

  render() {
    const {
      data,
      columns,
      defaultExpandAllRows = false,
      expandRowByClick = true
    } = this.props;
    const { loading } = this.state;
    return (
      <>
        <StyledTable
          pagination={false}
          loading={loading}
          dataSource={data}
          columns={columns}
          childrenColumnName="expenseDirections"
          expandRowByClick={expandRowByClick}
          expandIconAsCell={false}
          expandIconColumnIndex={1}
          expandIcon={(row) =>
          !!row.record.expenseDirections &&
          <AntIcon
            type={row.expanded ? 'up' : 'down'}
            style={{
              fontSize: '12px',
              float: 'right'
            }} />


          }
          bordered
          rowKey="rowId"
          style={{
            overflow: 'auto'
          }}
          scroll={{
            y: 'calc(100vh - 210px)',
            x: 'auto'
          }}
          rowClassName={(record) => {
            return record.rowId < 0 ? 'ant-table-row-colored' : null;
          }}
          defaultExpandAllRows={defaultExpandAllRows} />

      </>);

  }
}
